import { useTheme } from "@mui/material/styles";
import {
  Box,
  Chip,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Clear } from "@mui/icons-material";
import useStyles from "./styles";
import { OPCOES_TIPO_CLIENTE } from "./helpers";

// Filtro de pessoa física / jurídica.
//
// É um Select e não um Autocomplete porque o valor escolhido também precisa
// aparecer com o selo — `renderValue` resolve isso, enquanto o Autocomplete só
// consegue mostrar texto no campo depois de selecionado.
//
// `value` é 0, 1 ou null (sem filtro). Atenção ao 0: é PJ, não "vazio", então
// toda checagem aqui é contra null/undefined explicitamente.
export default function TipoClienteFilter({
  value = null,
  onChange = () => {},
  label = "Tipo de pessoa",
  id = "filtro-tipo-cliente",
  sx = {},
}) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const temValor = value !== null && value !== undefined && value !== "";

  const opcaoDe = (valor) =>
    OPCOES_TIPO_CLIENTE.find((opcao) => opcao.valor === valor);

  const selo = (opcao) => (
    <Chip
      label={opcao.sigla}
      size="small"
      sx={opcao.valor === 1 ? styles.chipPf : styles.chipPj}
    />
  );

  return (
    <FormControl variant="outlined" size="small" sx={sx}>
      <InputLabel id={`${id}-label`}>{label}</InputLabel>
      <Select
        labelId={`${id}-label`}
        id={id}
        label={label}
        value={temValor ? value : ""}
        onChange={(event) => {
          const escolhido = event.target.value;
          onChange(escolhido === "" ? null : Number(escolhido));
        }}
        renderValue={(selecionado) => {
          const opcao = opcaoDe(selecionado);
          if (!opcao) return "";
          return (
            <Box sx={styles.valorSelecionado}>
              {opcao.rotulo}
              {selo(opcao)}
            </Box>
          );
        }}
        endAdornment={
          temValor ? (
            <InputAdornment position="end" sx={{ mr: 2 }}>
              <IconButton
                size="small"
                onClick={(event) => {
                  event.stopPropagation();
                  onChange(null);
                }}
              >
                <Clear fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null
        }
      >
        {OPCOES_TIPO_CLIENTE.map((opcao) => (
          <MenuItem key={opcao.valor} value={opcao.valor}>
            <Box sx={styles.opcaoFiltro}>
              {opcao.rotulo}
              {selo(opcao)}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
